@if (user(); as currentUser) {
  <header class="app-header">
    <a class="app-header__brand" routerLink="/" aria-label="Vestorise Home">
      <svg class="app-header__logo" viewBox="0 0 100 100" width="24" height="24" aria-hidden="true">
        <path
          fill="#307CEC"
          fill-rule="evenodd"
          d="M 9.0,24.0 L 36.0,24.0 L 55.0,51.0 L 46.0,87.0 L 43.0,87.0 Z M 20.0,34.0 L 29.0,34.0 L 40.0,54.0 L 30.0,54.0 Z"
        />
        <path
          fill="#4BEFA1"
          fill-rule="evenodd"
          d="M 62.0,22.0 L 92.0,14.0 L 54.0,87.0 L 47.0,87.0 L 45.0,52.0 Z M 72.0,26.0 L 82.0,26.0 L 64.0,56.0 L 56.0,56.0 Z"
        />
      </svg>
      <span>Vestorise</span>
    </a>

    <div class="portfolio-switcher">
      <button
        type="button"
        mat-button
        [matMenuTriggerFor]="portfolioMenu"
        class="portfolio-switcher-btn"
      >
        <mat-icon class="portfolio-icon">workspaces</mat-icon>
        <span>{{ selectedPortfolioName() }}</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #portfolioMenu="matMenu">
        <button mat-menu-item (click)="selectPortfolio('ALL')">
          <mat-icon color="primary">
            {{ portfolioState.selectedPortfolioId() === 'ALL' ? 'check' : '' }}
          </mat-icon>
          <span>All Portfolios</span>
        </button>
        @for (p of portfolioState.portfolios(); track p.id) {
          <button mat-menu-item (click)="selectPortfolio(p.id)">
            <mat-icon color="primary">
              {{ portfolioState.selectedPortfolioId() === p.id ? 'check' : '' }}
            </mat-icon>
            <span>{{ p.name }}</span>
          </button>
        }
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="openManagePortfolios()">
          <mat-icon>settings</mat-icon>
          <span>Manage Portfolios...</span>
        </button>
      </mat-menu>
    </div>

    <nav class="app-header__nav" aria-label="Primary">
      <a routerLink="/dashboard" routerLinkActive="is-active">Dashboard</a>
      <a routerLink="/accounts" routerLinkActive="is-active">Accounts</a>
      <a routerLink="/holdings" routerLinkActive="is-active">Holdings</a>
      <a routerLink="/transactions" routerLinkActive="is-active">Transactions</a>
      <a routerLink="/watchlist" routerLinkActive="is-active">Watchlist</a>
      <a routerLink="/tax" routerLinkActive="is-active">Tax & Gains</a>
    </nav>

    <div class="app-header__actions">
      <button
        type="button"
        class="app-header__icon-btn"
        (click)="toggleTheme()"
        [attr.aria-label]="isDark() ? 'Switch to light mode' : 'Switch to dark mode'"
        [title]="isDark() ? 'Switch to light mode' : 'Switch to dark mode'"
      >
        <mat-icon>{{ isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
      </button>

      <button
        type="button"
        class="app-header__avatar-btn"
        [matMenuTriggerFor]="profileMenu"
        aria-label="User profile menu"
      >
        @if (photoUrl() && !avatarError()) {
          <img
            [src]="photoUrl()"
            alt="Profile picture"
            class="app-header__avatar-img"
            (error)="onAvatarError()"
          />
        } @else {
          <span class="app-header__avatar-fallback">{{ userInitial() }}</span>
        }
      </button>

      <mat-menu #profileMenu="matMenu" xPosition="before" class="app-profile-menu">
        <div class="app-profile-menu__header">
          <span class="app-profile-menu__email">{{ currentUser.email }}</span>
        </div>
        <button mat-menu-item routerLink="/settings">
          <mat-icon>settings</mat-icon>
          <span>Settings</span>
        </button>
        <button mat-menu-item (click)="signOut()">
          <mat-icon>logout</mat-icon>
          <span>Sign out</span>
        </button>
      </mat-menu>
    </div>
  </header>
}

<main class="app-content">
  <router-outlet />
</main>
